import script from "./DossierForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DossierForm.vue?vue&type=script&setup=true&lang=js"

import "./DossierForm.vue?vue&type=style&index=0&id=79687cde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79687cde"]])

export default __exports__